var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobHomeViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.3125C16.5673 2.98794 16.0409 2.8125 15.5 2.8125C14.9591 2.8125 14.4327 2.98794 14 3.3125L5.25 9.875C4.93951 10.1079 4.6875 10.4098 4.51393 10.757C4.34036 11.1041 4.25 11.4869 4.25 11.875V23.75C4.25 24.413 4.51339 25.0489 4.98223 25.5178C5.45107 25.9866 6.08696 26.25 6.75 26.25H11.625C11.9897 26.25 12.3394 26.1051 12.5973 25.8473C12.8551 25.5894 13 25.2397 13 24.875V18.75C13 18.087 13.2634 17.4511 13.7322 16.9822C14.2011 16.5134 14.837 16.25 15.5 16.25C16.163 16.25 16.7989 16.5134 17.2678 16.9822C17.7366 17.4511 18 18.087 18 18.75V24.875C18 25.2397 18.1449 25.5894 18.4027 25.8473C18.6606 26.1051 19.0103 26.25 19.375 26.25H24.25C24.913 26.25 25.5489 25.9866 26.0178 25.5178C26.4866 25.0489 26.75 24.413 26.75 23.75V11.875C26.75 11.4869 26.6596 11.1041 26.4861 10.757C26.3125 10.4098 26.0605 10.1079 25.75 9.875L17 3.3125Z",
    fill: "#5A189A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobHomeViolet);
export default __webpack_public_path__ + "static/media/mob-home-violet.891d9c939826e162f5788d3c482ae443.svg";
export { ForwardRef as ReactComponent };